import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import {get} from 'lodash';

import appActions from '../../actions/actions';
import multipleAccountsActions from '../../actions/multipleAccounts';
import confirmBrandActions from '../../actions/confirmBrand';
import MultipleAccounts from '../MultipleAccounts/MultipleAccounts';

function mapStateToProps(state) {
    return {
        publicUuid: get(state, 'app.publicUuid', ''),
        emailAddress: get(state, 'app.userEmailAddress', ''),
        integratedBrandsPrimarySiteList: get(state, 'app.integratedBrandsPrimarySiteList', []),
        translations: state.app.translations,
        serviceError: get(state, 'multipleAccounts.serviceError', ''),
        userType: get(state, 'app.userType', ''),
        isConsolidationRequired: get(state, 'app.isConsolidationRequired', true),
        dyff: get(state, 'app.dyff', ''),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        appActions: bindActionCreators(appActions, dispatch),
        multipleAccountsActions: bindActionCreators(multipleAccountsActions, dispatch),
        confirmBrandActions: bindActionCreators(confirmBrandActions, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
export default class MultipleAccountsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.triggerEdapPageViewAction = this.triggerEdapPageViewAction.bind(this);
        this.props.appActions.enableLoadOverLay(false);
        this.handleBrandSelection = this.handleBrandSelection.bind(this);
        this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
    }

    triggerEdapPageViewAction() {
        this.props.appActions.triggerEdapPageView(this.props.publicUuid, 'Multiple Accounts Page');
    }

    handleBrandSelection(event, primarySite) {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Continue',
            eventaction: 'Brand Selected'
        }, {});
        this.props.confirmBrandActions.confirmBrand(primarySite);
        this.props.appActions.changeAppState('CONFIRM_BRAND');
    }

    handleFormSubmit = (event) => {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Continue',
            eventaction: 'Multiple Accounts Continue'
        }, {});
        this.props.appActions.changeAppState('BANKING_LOCATION');
    }

    handleAlertDismiss() {
        this.props.multipleAccountsActions.dismissAlertBox();
    }

    render() {
        return (
            <MultipleAccounts publicUuid={this.props.publicUuid}
                translations={this.props.translations}
                handleFormSubmit={this.handleFormSubmit}
                handleLanguageCurrencyMismatch={this.props.dyff?.SHARED_HANDLE_SSO_LANGUAGE_CURRENCY_MISMATCH}
                numberOfAccounts={this.props.integratedBrandsPrimarySiteList.length}
                triggerEdapPageViewAction={this.triggerEdapPageViewAction}
                integratedBrandsPrimarySiteList={this.props.integratedBrandsPrimarySiteList}
                emailAddress={this.props.emailAddress}
                handleBrandSelection = {this.handleBrandSelection}
                serviceError={this.props.serviceError}
                handleAlertDismiss={this.handleAlertDismiss}
            />
        );
    }
}

MultipleAccountsContainer.propTypes = {
    publicUuid: PropTypes.string,
    translations: PropTypes.any, // eslint-disable-line react/forbid-prop-types
};
MultipleAccountsContainer.defaultProps = {
    publicUuid: '-1'
};
